import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const eventDetailsSearchSchema = z.object({
  edit: z.enum(['true']).optional(),
});

export type EventDetailsSearchSchema = z.infer<typeof eventDetailsSearchSchema>;

export const Route = createFileRoute(
  '/_private/_route/_internal/events/$eventId/details/',
)({
  validateSearch: eventDetailsSearchSchema,
});
